import { render, staticRenderFns } from "./MiscTab.vue?vue&type=template&id=8968b26a&scoped=true"
import script from "./MiscTab.vue?vue&type=script&lang=ts"
export * from "./MiscTab.vue?vue&type=script&lang=ts"
import style0 from "./MiscTab.vue?vue&type=style&index=0&id=8968b26a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8968b26a",
  null
  
)

export default component.exports